import React from 'react';
import { NeuroMessage } from '@ignitesales/neuro-application';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui';
import classnames from 'classnames';

const ContactMeConfirmationModal = ({active, onClose, className}) => {
  const classes = classnames(className, 'modal--dialog');

  const onCloseClick = () => {
    onClose();
    setMessageSent(false);
  };

  return active && (
    <Modal
      show={active}
      className={classes}
      title={intl.formatMessage({id: 'contactMeConfirmation.title'})}
      onClose={onCloseClick}
      nodeId="root"
      closeBtn={<i className="fa fa-close" role="img" aria-label="Close" />}
    >
      <div className="modal__content">
        <label>
          <NeuroMessage id="contactMeConfirmation.submitted" />
        </label>
        <button className="btn btn-primary" type="submit" onClick={onCloseClick}>
          <NeuroMessage id="contactMeConfirmation.close" />
        </button>
      </div>
    </Modal>
  );
};

export default ContactMeConfirmationModal;
